import React, { FunctionComponent } from 'react';

interface MainProps {
  className?: string;
}

const Main: FunctionComponent<MainProps> = ({ children, className }) => {
  return <main className={className}>{children}</main>;
};

export default Main;
